import classNames from "classnames";
import './SectorIcon.scss';

interface IProps {
  sector? : number;
  solid?: boolean;
}
export const SectorIcon = ({sector = 0, solid}: IProps) => {
  return (
    <div className={classNames('sector-icon', {solid})}>
      <div className={`sector-icon_square${!sector ? " active" : ""}`}></div>
      <div className={`sector-icon_square${(sector === 1) ? " active" : ""}`}></div>
      <div className={`sector-icon_square${(sector === 2) ? " active" : ""}`}></div>
      <div className={`sector-icon_square${(sector === 3) ? " active" : ""}`}></div>
    </div>
  )
}
